<template>
  <v-dialog width="500" v-model="dialog" :overlay=false>
    <v-card v-if="comb != null">
      <v-card-title>
        <div class="headline">Nuova combinazione</div>
      </v-card-title>
      <v-card-text>
        <DescrEditor 
          v-model="comb.customContent.descrizione" 
          :currentLang="currentLang" 
          @changeLang="changeLang"
          @setDescr="setDescr" />
        <v-text-field
          type="number"
          max="5"
          label="Numero di sottogruppi"
          v-model="sottoGruppi"
        ></v-text-field>
        <PriceEditor soloMetti @setprice="setPrice" :listinoDaMenu="listino" v-model="comb.customContent.prezzo" type="prod"/>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat primary @click.native="close">Annulla</v-btn>
        <v-btn flat primary @click.native="save">Salva</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Crea un dialog in cui fornire impostazioni della combinazione
 * @module components/common/CombCreator
 */
export default {
    name: 'combCreator',
    data () {
      return {
        edited: null,
        comb: null,
        currentLang: 'IT',
        sottoGruppi: 0
      }
    },
    methods: {
      close () {
        this.$emit('close', null)
      },
      save () {

        this.comb.customContent.prezzo = this.comb.customContent.prezzo.map(prezzo => 
        Object.assign({}, prezzo, {
          prezzop: utils.toNumeral(prezzo.prezzop).convert(), 
          prezzom: utils.toNumeral(prezzo.prezzom).convert()
        }))

        this.$emit('close', {comb: this.comb, sottogruppi: this.sottoGruppi})
      },
      changeLang (lang) {
        this.currentLang = lang
      },
      setDescr (descr) {
        this.comb.customContent.descrizione = descr;
      },
      setPrice (newPrezzo) {
        this.comb.customContent.prezzo = newPrezzo
      }
    },
    watch: {
      editing () {
        this.comb = this.editing
      }
    },
    computed: {
      dialog: {
        get () {
          return this.editing != null
        },
        set () {
          this.$emit('close')
        }
      }
    },
    /**
     * @prop editing {object} - La combinazione
     * @prop listino {string} - Listino di riferimento
    */
    props: ['editing', 'listino']
}
</script>

<style lang="stylus" scoped>
  .container
    padding: 64px 0 0 0
    height: 100vh
</style>


// WEBPACK FOOTER //
// src/components/common/CombCreator.vue